import { RequestPerformer } from '@/api/api-requests-factory';
import { useEnvStore } from '@/store/env.store';
import { storeToRefs } from 'pinia';
import { DictionaryApiResources } from '@/api/dictionary';
import { PsManagementApiResources } from '@/api/ps-management';
import { FileApiResources } from '@/api/file';
import { TransactionsApiResources } from '@/api/transactions';
import { CashierSettingsApiResources } from '@/api/cashier-settings';
import { PspSortingApiResources } from '@/api/psp-sorting';
import { PspTagApiResources } from '@/api/psp-tag';
import { LogsApiResources } from '@/api/logs-page';
import { AuthApiResources } from '@/api/auth';
import { MultibrandApiResourse } from '@/api/multibrand';
import { CurrencyApiResources } from '@/api/currency';
import { LimitExceptionsUploadApiResources } from '@/api/limit-exceptions-upload';

export interface ApiResources {
  file: FileApiResources;
  dictionary: DictionaryApiResources;
  psManagement: PsManagementApiResources;
  transactions: TransactionsApiResources;
  logs: LogsApiResources;
  auth: AuthApiResources;
  cashierSettings: CashierSettingsApiResources;
  pspSorting: PspSortingApiResources;
  pspTag: PspTagApiResources;
  multibrand: MultibrandApiResourse;
  currency: CurrencyApiResources;
  limitExceptionsUpload: LimitExceptionsUploadApiResources;
}

export class ApiResourcesFactory {
  public getInstance(basePerformer: RequestPerformer): ApiResources {
    const { BACKOFFICE_API_URL, MULTIBRAND_API_URL, MULTIBRAND_API_HOST, WL_SLUG } = storeToRefs(useEnvStore());

    return {
      file: new FileApiResources(basePerformer, BACKOFFICE_API_URL),
      dictionary: new DictionaryApiResources({
        requestPerformer: basePerformer,
        apiUrl: BACKOFFICE_API_URL,
        multibrandApiHost: MULTIBRAND_API_HOST,
      }),
      psManagement: new PsManagementApiResources({
        requestPerformer: basePerformer,
        apiUrl: BACKOFFICE_API_URL,
        multibrandApiHost: MULTIBRAND_API_HOST,
        wlSlug: WL_SLUG,
      }),
      transactions: new TransactionsApiResources(basePerformer, MULTIBRAND_API_HOST),
      logs: new LogsApiResources(basePerformer, BACKOFFICE_API_URL),
      auth: new AuthApiResources(basePerformer, BACKOFFICE_API_URL),
      cashierSettings: new CashierSettingsApiResources(basePerformer, BACKOFFICE_API_URL),
      pspSorting: new PspSortingApiResources(basePerformer, MULTIBRAND_API_URL),
      multibrand: new MultibrandApiResourse(basePerformer, MULTIBRAND_API_URL),
      pspTag: new PspTagApiResources(basePerformer, MULTIBRAND_API_HOST),
      currency: new CurrencyApiResources(basePerformer, MULTIBRAND_API_HOST),
      limitExceptionsUpload: new LimitExceptionsUploadApiResources(basePerformer, MULTIBRAND_API_URL),
    };
  }
}
